export const ANON_SELECTED_UNIVERSITY_KEY = "annon_selected_university";
export const ANON_SELECTED_SUBJECT_KEY = "annon_selected_subject";
export const ACCESS_TOKEN = "anonToken";
export const SELECTED_COURSE = "selectedCourse";
export const SELECTED_LECTURE = "selectedLecture";
export const LAST_VIEWED_SLIDE = "lastViewedSlide";
export const USER = "anon_user";
export const USER_ROLE = "anon_user_role";
export const TEACHER_ADMIN = "teacher_admin";
